// extracted by mini-css-extract-plugin
export default {"wrap":"EditableAvatar_wrap__mWs+f","avatar":"EditableAvatar_avatar__duZJ6","button":"EditableAvatar_button__5YzG+"};